import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
import { ref, onMounted, computed, onBeforeUnmount } from "../../adapter-vue";
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import SearchInput from "./search-input/index.vue";
import SearchContainer from "./search-container/index.vue";
import SearchResult from "./search-result/index.vue";
import SearchMore from "./search-more/index.vue";
import { searchMessageTypeDefault } from "./search-type-list";
import { searchMessageTimeDefault } from "./search-time-list";
import { isPC, isUniFrameWork } from "../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    searchType: {
      "default": function _default() {
        return isUniFrameWork ? "conversation" : "global";
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var globalSearchRef = ref();
    // 当前会话
    var _currentConversationID = ref("");
    // 控制搜索状态
    var searchingStatus = ref(false);
    // 是否展示指定会话内搜索: 与 TUIChat 交互，由 TUIChat MessageInputToolBar 中 "查看历史消息ICON" 控制
    var _isShowInConversationSearch = ref(isUniFrameWork ? true : false);
    // 是否全屏搜索 - 移动端正在搜索时全屏搜索
    var isFullScreen = computed(function () {
      return !isPC && (props.searchType === "global" && searchingStatus.value || props.searchType === "conversation" && _isShowInConversationSearch.value);
    });
    var initSearchValue = function initSearchValue(searchType) {
      TUIStore.update(StoreName.CUSTOM, "currentSearchInputValue", {
        value: "",
        searchType: searchType
      });
      TUIStore.update(StoreName.CUSTOM, "currentSearchMessageType", {
        value: searchMessageTypeDefault[searchType],
        searchType: searchType
      });
      TUIStore.update(StoreName.CUSTOM, "currentSearchMessageTime", {
        value: searchMessageTimeDefault,
        searchType: searchType
      });
    };
    onMounted(function () {
      // init with default value
      ["global", "conversation"].forEach(function (type) {
        initSearchValue(type);
      });
      // watch store change
      TUIStore.watch(StoreName.CONV, {
        currentConversationID: function currentConversationID(conversationID) {
          if (!isUniFrameWork && _currentConversationID.value !== conversationID) {
            // pc端 单页面 切换会话，关闭搜索
            closeInConversationSearch();
          }
          _currentConversationID.value = conversationID;
        }
      });
      TUIStore.watch(StoreName.CUSTOM, {
        currentSearchingStatus: function currentSearchingStatus(value) {
          if ((value === null || value === void 0 ? void 0 : value.searchType) === props.searchType) {
            searchingStatus.value = value === null || value === void 0 ? void 0 : value.isSearching;
            // global search ui bind on click outside close
            if ((value === null || value === void 0 ? void 0 : value.searchType) === "global" && globalSearchRef.value) {
              value !== null && value !== void 0 && value.isSearching ? onClickOutside(globalSearchRef.value) : removeClickListener(globalSearchRef.value);
            }
          }
        },
        isShowInConversationSearch: function isShowInConversationSearch(value) {
          _isShowInConversationSearch.value = value ? true : false;
          _isShowInConversationSearch.value && initSearchValue(props.searchType);
        }
      });
    });
    onBeforeUnmount(function () {
      removeClickListener(globalSearchRef === null || globalSearchRef === void 0 ? void 0 : globalSearchRef.value);
    });
    function closeInConversationSearch() {
      TUIStore.update(StoreName.CUSTOM, "isShowInConversationSearch", false);
    }
    // 全局搜索dialog-点击外侧关闭
    // click outside
    var clickOutside = false;
    var clickInner = false;
    var onClickOutside = function onClickOutside(component) {
      if (isUniFrameWork || !isPC) {
        return;
      }
      document.addEventListener("click", onClickDocument);
      (component === null || component === void 0 ? void 0 : component.addEventListener) && (component === null || component === void 0 ? void 0 : component.addEventListener("click", onClickTarget));
    };
    var removeClickListener = function removeClickListener(component) {
      if (isUniFrameWork || !isPC) {
        return;
      }
      document.removeEventListener("click", onClickDocument);
      (component === null || component === void 0 ? void 0 : component.removeEventListener) && (component === null || component === void 0 ? void 0 : component.removeEventListener("click", onClickTarget));
    };
    var onClickDocument = function onClickDocument() {
      clickOutside = true;
      if (!clickInner && clickOutside) {
        TUIStore.update(StoreName.CUSTOM, "currentSearchingStatus", {
          isSearching: false,
          searchType: props.searchType
        });
        removeClickListener(globalSearchRef === null || globalSearchRef === void 0 ? void 0 : globalSearchRef.value);
      }
      clickOutside = false;
      clickInner = false;
    };
    var onClickTarget = function onClickTarget() {
      clickInner = true;
    };
    return function (_ctx, _cache) {
      return _ctx.searchType === 'global' || _ctx.searchType === 'conversation' && _unref(_isShowInConversationSearch) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass(['tui-search', !_unref(isPC) && 'tui-search-h5', "tui-search-main-".concat(_ctx.searchType), _unref(isFullScreen) && 'tui-search-h5-full-screen'])
      }, [_ctx.searchType === 'global' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass(['tui-search-global', !_unref(isPC) && 'tui-search-h5-global']),
        ref_key: "globalSearchRef",
        ref: globalSearchRef
      }, [_createElementVNode("div", {
        "class": _normalizeClass(['tui-search-global-header', !_unref(isPC) && 'tui-search-h5-global-header'])
      }, [_createVNode(SearchInput, {
        searchType: _ctx.searchType
      }, null, 8, ["searchType"]), _unref(isPC) || !_unref(searchingStatus) ? (_openBlock(), _createBlock(SearchMore, {
        key: 0,
        searchType: _ctx.searchType
      }, null, 8, ["searchType"])) : _createCommentVNode("", true)], 2), _unref(searchingStatus) ? (_openBlock(), _createBlock(SearchContainer, {
        key: 0,
        popupPosition: "bottom",
        searchType: _ctx.searchType
      }, {
        result: _withCtx(function () {
          return [_createVNode(SearchResult, {
            searchType: _ctx.searchType
          }, null, 8, ["searchType"])];
        }),
        _: 1
      }, 8, ["searchType"])) : _createCommentVNode("", true)], 2)) : _ctx.searchType === 'conversation' && _unref(_isShowInConversationSearch) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": _normalizeClass(['tui-search-conversation', !_unref(isPC) && 'tui-search-h5-conversation'])
      }, [_createVNode(SearchContainer, {
        popupPosition: "aside",
        searchType: _ctx.searchType,
        onCloseInConversationSearch: closeInConversationSearch
      }, {
        input: _withCtx(function () {
          return [_createVNode(SearchInput, {
            searchType: _ctx.searchType
          }, null, 8, ["searchType"])];
        }),
        result: _withCtx(function () {
          return [_createVNode(SearchResult, {
            searchType: _ctx.searchType
          }, null, 8, ["searchType"])];
        }),
        _: 1
      }, 8, ["searchType"])], 2)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true);
    };
  }
});